module.exports = __webpack_public_path__ + "static/media/20200921_171623.78e4cbc7.jpg";